import {Legend, LegendItem, LegendItemType} from './components'

interface GanttChartLegend {
  legendItems: LegendItemType[]
}

export const GanttChartLegend: React.FC<GanttChartLegend> = ({legendItems}) => {
  return (
    <Legend testId="gantt_chart_legend" sx={{justifyContent: 'flex-end'}}>
      {legendItems.map((item) => (
        <LegendItem key={item.id} {...item}>
          {item.children}
        </LegendItem>
      ))}
    </Legend>
  )
}
